T.ProcessPayment = Class(
	/**
	 * @lends {T.ProcessPayment#}
	 */
	{
		paymentId: null,
		onSuccess: D.doNothing,
		onFailure: D.doNothing,
		apiCall: null,

		__construct(paymentId, onSuccess, onFailure, apiCall) {
			this.paymentId = paymentId;
			this.onSuccess = onSuccess;
			this.onFailure = onFailure;

			this.node = mkE({
				tag: 'div',
				id: 'process-payment',
				els: [
					this._animationContainer = mkE({
						tag: 'div',
						id: 'process-payment-animation'
					}),
					{
						tag: 'h4',
						text: D.Lang.get('payments.processing')
					}
				]
			});

			if (D.APP_WEBVIEW) {
				D.sendPostMessage({
					status: 'checking',
				});
			}

			this._checkPayment(apiCall);
		},

		onShow() {
			D.lottie({
				container: this._animationContainer,
				renderer: 'svg',
				loop: true,
				autoplay: true,
				path: '/assets/lottie/loading.json'
			});
		},

		_checkPayment(apiCall) {
			this._mGetPaymentStatus = new DR.services.GetPaymentStatus();
			this._mGetPaymentStatus.paymentId = this.paymentId;
			this._mGetPaymentStatus.onLoad = this._onCheckPaymentStatus;
			this._mGetPaymentStatus.onError = this._onCheckPaymentStatusError;
			if (apiCall) {
				apiCall.addMethod(this._mGetPaymentStatus);
			} else {
				this._mGetPaymentStatus.call();
			}
		},

		_onCheckPaymentStatus() {
			switch (this._mGetPaymentStatus.re.status) {
				case DR.services.struct.PaymentStatus.STATUS_SUCCESSFUL:
					if (D.APP_WEBVIEW) {
						D.sendPostMessage({
							status: 'success',
						});
						return;
					}
					this.onSuccess(this._mGetPaymentStatus.re.amount, this._mGetPaymentStatus.re.itemCount);
					break;
				case DR.services.struct.PaymentStatus.STATUS_FAILED:
					if (D.APP_WEBVIEW) {
						D.sendPostMessage({
							status: 'error',
							message: 'Payment failed',
						});
						return;
					}
					this.onFailure();
					break;
				default:
					setTimeout(this._checkPayment, 5000);
					break;
			}
		},

		_onCheckPaymentStatusError() {
			if (D.APP_WEBVIEW) {
				D.sendPostMessage({
					status: 'error',
					message: 'Payment check failed',
				});
				return;
			}
			Section.navigate('/');
		}
	},
	mkE.Base
);